import request from '@/utils/request'

// 获取分销商品列表
export function listAffiliateProduct(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/affiliateProduct.listAffiliateProduct',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 添加分销商品
export function saveAffiliateProduct(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/affiliateProduct.saveAffiliateProduct',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新分销商品
export function updateAffiliateProduct(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/affiliateProduct.updateAffiliateProduct',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除分销商品
export function deleteAffiliateProduct(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/affiliateProduct.deleteAffiliateProduct',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}